import { useCallback, useContext } from 'react';
import Notification from 'components/notification';
import { NOTIFICATION_TYPES } from 'constants/components/notification';
import {
  LicenseErrorInfo,
  getLicenseErrorInfo,
  licenseRejectionMessage,
} from 'constants/errors/license_error_codes';
import { SessionContext } from 'contexts/session';

interface LicenseRejectionCopy {
  fallback: string;
  outcome?: string;
  onRefresh?: () => void;
}

// Says why a license change failed: the code's message, or the fallback without one. A code means
// the counts on screen may be stale, so it also refetches `/me` and the full account.
const useLicenseRejection = () => {
  const { actions } = useContext(SessionContext);
  return useCallback(
    (
      error: unknown,
      { fallback, outcome, onRefresh }: LicenseRejectionCopy
    ): LicenseErrorInfo | null => {
      const licenseError = getLicenseErrorInfo(error);
      const message =
        licenseError && outcome
          ? licenseRejectionMessage(licenseError, outcome)
          : licenseError?.message;
      Notification({ text: message ?? fallback, type: NOTIFICATION_TYPES.ERROR });
      if (licenseError) {
        onRefresh?.();
        actions.refreshSession();
        actions.refreshAccounts();
      }
      return licenseError;
    },
    [actions]
  );
};

export default useLicenseRejection;
